export default __webpack_public_path__ + "static/media/p4-10.8ae94edf.png";